import { graphql } from 'gatsby';
import React from 'react';

import BlogSeo from '../components/Blog/BlogSeo';
import Layout from '../components/Layouts/Layout';
import ResourceListingPage from '../components/Resources/ResourceListingPage';
import { sortByPublishDate } from '../tools/mappers';
import * as styles from './solutionListing.module.scss';

const SolutionListing = ({ data, pageContext }) => {
  let source = data?.solution;
  let title = data?.solution?.title;
  if (pageContext.isGuidesReports) {
    let merged = {
      blogPosts: [],
      caseStudies: [],
      resources: [],
      walledResources: [],
    };
    data?.guidesReports?.nodes.forEach((content) => {
      if (content.blogPosts) merged.blogPosts.push(...content.blogPosts);
      if (content.caseStudies) merged.caseStudies.push(...content.caseStudies);
      if (content.resources) merged.resources.push(...content.resources);
      if (content.walledResources) merged.walledResources.push(...content.walledResources);
    });

    // Hardcode benchmark report
    if (data.benchmarkReport) {
      merged.walledResources.push({
        ...data.benchmarkReport,
        contentType: {
          slug: 'report',
          title: 'Report',
          viewLabel: 'Read the report',
        },
        title: '2025 Digital Benchmark Report | Explore Product Experience Trends',
        description: {
          description:
            'Get insights from 14B+ sessions. Learn what drives drop-off, where users engage, and how your industry compares.',
        },
      });
    }

    source = merged;
    title = 'Guides & Reports';
  }

  const posts = [
    ...(source?.blogPosts || []),
    ...(source?.caseStudies || []),
    ...(source?.resources || []),
    ...(source?.walledResources || []),
  ].sort(sortByPublishDate);
  return (
    <Layout className={styles.background}>
      <ResourceListingPage content={data?.content} title={title} posts={posts} />
    </Layout>
  );
};

export const Head = ({ location }) => <BlogSeo slug={location.pathname} />;

export default SolutionListing;

export const query = graphql`
  query getSolution($slug: String!) {
    solution: contentfulTaxSolution(slug: { eq: $slug }) {
      slug
      title
      ...GroupedSolutionArticles
    }
    guidesReports: allContentfulTaxContentType(
      filter: { slug: { regex: "/^(Guide|Report)$/i" }, node_locale: { eq: "en-US" } }
    ) {
      nodes {
        slug
        title
        ...GroupedArticlesTaxContent
      }
    }
    benchmarkReport: contentfulPageStandard(contentful_id: { eq: "1cUH8EMCrqFyRMko8fJdVX" }) {
      __typename
      id
      createdAt
      slug
      pageMetaData {
        ogImage {
          title
          file {
            url
            contentType
          }
          description
          gatsbyImageData
          resize: gatsbyImageData(layout: FULL_WIDTH, placeholder: NONE, width: 356, height: 187)
        }
      }
    }
    #    videoLibrary: contentfulTaxSolution(slug: { eq: "video-library" }, node_locale: { eq: "en-US" }) {
    #      slug
    #      title
    #      ...GroupedSolutionArticles
    #    }
  }
`;
